export default __webpack_public_path__ + "static/media/Abyssal Cloak of the Hell Walker.cd74dcee.jpg";